<template>
  <div>
    <f7-block strong class="pt-0 mt-0" v-if="!_.isEmpty(over_point_config.general_overpoint)">
      <f7-row no-gap>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Lô"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_bao"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_bao = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Đề"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Đề t.hợp"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi_2"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi_2 = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
      </f7-row>
      <f7-row no-gap>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Đầu Nhất"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_daunhat"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_daunhat = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Giải Nhất"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_giainhat"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_giainhat = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05"></f7-col>
      </f7-row>
      <f7-row no-gap>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="3Càng"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_duoi"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_duoi = $event.target.value">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05"></f7-col>
        <f7-col class="pl-05 pr-05"></f7-col>
      </f7-row>
      <f7-row no-gap v-if="region === 'mb'">
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Xiên 2"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_2"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_2 = $event.target.value">
              >
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Xiên 3"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_3"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_3 = $event.target.value">
              >
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col class="pl-05 pr-05">
          <f7-list class="mt-0 mb-0 no-border">
            <f7-list-input
              outline
              floating-label
              label="Xiên 4"
              type="text"
              class="padding-xs"
              :value="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_4"
              @input="over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_4 = $event.target.value">
              >
            </f7-list-input>
          </f7-list>
        </f7-col>
      </f7-row>
      <f7-row class="mt-2">
        <f7-col>
          <f7-button fill color="primary" @click.prevent="updateOverPointConfig">LƯU</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    region: String,
    playStyle: String,
    custId: String,
    enableBlockNumber: Boolean
  },
  data() {
    return {
      tab_config: 'chung',
      type_input_over_config: 'all',
      filter_channel_options: {
        mb: {
          monday: {
            mb: 'mb'
          },
          tuesday: {
            mb: 'mb'
          },
          wednesday: {
            mb: 'mb'
          },
          thursday: {
            mb: 'mb'
          },
          friday: {
            mb: 'mb'
          },
          saturday: {
            mb: 'mb'
          },
          sunday: {
            mb: 'mb'
          },
        },
        mn: {
          monday: {
            dc: 'tp',
            dp: 'dt',
            dp2: 'cm'
          },
          tuesday: {
            dc: 'bt',
            dp: 'vt',
            dp2: 'bl'
          },
          wednesday: {
            dc: 'dn',
            dp: 'ct',
            dp2: 'st'
          },
          thursday: {
            dc: 'tn',
            dp: 'ag',
            dp2: 'bt'
          },
          friday: {
            dc: 'vl',
            dp: 'bd',
            dp2: 'tv'
          },
          saturday: {
            dc: 'tp',
            dp: 'la',
            dp2: 'bp',
            dp3: 'hg'
          },
          sunday: {
            dc: 'tg',
            dp: 'kg',
            dp2: 'dl'
          },
        },
        mt: {
          monday: {
            dc: 'py',
            dp: 'th'
          },
          tuesday: {
            dc: 'dl',
            dp: 'qn'
          },
          wednesday: {
            dc: 'dn',
            dp: 'kh'
          },
          thursday: {
            dc: 'bd',
            dp: 'qt',
            dp2: 'qb'
          },
          friday: {
            dc: 'gl',
            dp: 'nt'
          },
          saturday: {
            dc: 'dn',
            dp: 'qn',
            dp2: 'dno'
          },
          sunday: {
            dc: 'kt',
            dp: 'kh',
            dp2: 'th'
          },
        }
      },
      detail_tab: 'monday',
      tab_region_block_number: 'mn',
      form_block_numbers: {
        content: "",
        week_day: [],
        region: "",
        play_style: "",
        apply_all_days: 0
      },
      block_numbers: [],
      selectedBlockNumberItemIdx: -1,
      popupNumbers: false
    }
  },
  computed: {
    ...mapState(['selected_customer', 'selected_drawdate', 'user_info', 'customers', 'friends']),
    full_datename() {
      return this.$moment(this.selected_drawdate, 'dd/mm/yyyyy').format('dddd')
    },
    first_channel() {
      let real_region = this.region;
      if (this.playStyle === 'mb_hanoi') {
        real_region = 'mb_hanoi';
      }
      return Object.keys(this.over_point_config.general_overpoint[real_region][this.full_datename.toLowerCase()])[0];
    },
    dc() {
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dc;
    },
    dp() {
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp;
    },
    dp2() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2;
    },
    dp3() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3;
    },
    over_point_config() {
      return {
        number_overpoint: {},
        general_overpoint: this.selected_customer.over_point_config
      };
    }
  },
  methods: {
    toggleFormBlockNumbersWeekday(name) {

    },
    getBlockNumbers() {

    },
    async submitFormBlockNumbers() {

    },
    deleteBlockNumbers(idx) {

    },
    changeAllConfig(type, name, value) {
      if (type === '2c') {
        this._.each(this.over_point_config.general_overpoint['mb_hanoi'], (v2, datename) => {
          this.over_point_config.general_overpoint['mb_hanoi'][datename]['mb']['2c'][name] = value;
        });
      }
      else if (type === '3c') {
        this._.each(this.over_point_config.general_overpoint['mb_hanoi'], (v2, datename) => {
          this.over_point_config.general_overpoint['mb_hanoi'][datename]['mb']['3c'][name] = value;
        });
      }
      else if (type === '4c') {
        this._.each(this.over_point_config.general_overpoint['mb_hanoi'], (v2, datename) => {
          this.over_point_config.general_overpoint['mb_hanoi'][datename]['mb']['4c'][name] = value;
        });
      }
      else if (type === 'da') {
        this._.each(this.over_point_config.general_overpoint['mb_hanoi'], (v2, datename) => {
          this.over_point_config.general_overpoint['mb_hanoi'][datename]['mb']['2c'][name] = value;
        });
      }
      else if (type === 'dx') {
        this._.each(this.over_point_config.general_overpoint['mb_hanoi'], (v2, datename) => {
          this.over_point_config.general_overpoint['mb_hanoi'][datename]['mb']['2c'][name] = value;
        });
      }
    },
    changeTypeInputConfig() {
      let self = this;

      if (this.region === 'mn') {
        this.selected_customer.config_ui.type_input_over_config_mn = this.type_input_over_config;
      }
      else if (this.region === 'mt') {
        this.selected_customer.config_ui.type_input_over_config_mt = this.type_input_over_config;
      }
      else if (this.region === 'mb') {
        this.selected_customer.config_ui.type_input_over_config_mb = this.type_input_over_config;
      }
      else if (this.region === 'mb_ngan') {
        this.selected_customer.config_ui.type_input_over_config_mb = this.type_input_over_config;
      }
      else if (this.region === 'mb_hanoi') {
        this.selected_customer.config_ui.type_input_over_config_mb = this.type_input_over_config;
      }

      this.$store.dispatch('changeCustomerUIConfig', {
        customer_id: self.custId,
        config_ui: self.selected_customer.config_ui
      }).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
    updateOverPointConfig() {
      this.changeAllConfig('2c', 'over_point_daunhat', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_daunhat);
      this.changeAllConfig('2c', 'over_point_giainhat', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_giainhat);
      this.changeAllConfig('2c', 'over_point_dau', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dau);
      this.changeAllConfig('2c', 'over_point_duoi', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi);
      this.changeAllConfig('2c', 'over_point_duoi_2', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_duoi_2);
      this.changeAllConfig('2c', 'over_point_bao', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_bao);
      this.changeAllConfig('2c', 'over_point_baylo', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_baylo);
      this.changeAllConfig('2c', 'over_point_tamlo', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_tamlo);
      this.changeAllConfig('da', 'over_point_da', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_da);
      this.changeAllConfig('dx', 'over_point_dx', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx);
      this.changeAllConfig('dx', 'over_point_dx_2', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_2);
      this.changeAllConfig('dx', 'over_point_dx_3', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_3);
      this.changeAllConfig('dx', 'over_point_dx_4', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['2c'].over_point_dx_4);
      this.changeAllConfig('3c', 'over_point_dau', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_dau);
      this.changeAllConfig('3c', 'over_point_duoi', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_duoi);
      this.changeAllConfig('3c', 'over_point_bao', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_bao);
      this.changeAllConfig('3c', 'over_point_baylo', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['3c'].over_point_baylo);
      this.changeAllConfig('4c', 'over_point_bao', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['4c'].over_point_bao);
      this.changeAllConfig('4c', 'over_point_baylo', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['4c'].over_point_baylo);
      this.changeAllConfig('4c', 'over_point_duoi', this.over_point_config.general_overpoint['mb_hanoi']['monday']['mb']['4c'].over_point_duoi);

      this.$f7.dialog.preloader();

      this.$store.dispatch('changeCustomerConfig', {
        customer_id: this.custId,
        over_point_config: this.over_point_config.general_overpoint
      }).then(() => {
        this.$f7.dialog.close();
        this.changeTypeInputConfig();
        this.$emit('updatedConfig');
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    }
  },
  mounted() {
    if (this.region === 'mn') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mn;
    }
    else if (this.region === 'mt') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mt;
    }
    else if (this.region === 'mb') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mb;
    }
    else if (this.region === 'mb_ngan') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mb;
    }
    else if (this.region === 'mb_hanoi') {
      this.type_input_over_config = this.selected_customer.config_ui.type_input_over_config_mb;
    }

    if (this.playStyle === 'mb_hanoi') {
      this.type_input_over_config = 'all';
    }
  }
};
</script>
